/**
 * Allowed keys in a structured counter offer payload.
 * SINGLE SOURCE OF TRUTH (frontend mirror) — canonical list lives in
 * supabase/functions/_shared/constants.ts → ALLOWED_COUNTER_OFFER_KEYS
 *
 * Keep these two files in sync. The CI test in
 * src/__tests__/counterOfferKeysParity.test.ts enforces parity.
 */
export const ALLOWED_COUNTER_OFFER_KEYS = [
  'negotiated_price_cents',
  'apr_percent',
  'down_payment_cents',
  'term_months',
  'monthly_payment_cents',
  'due_at_signing_cents',
  'mileage_per_year',
  'cash_price_cents',
  'trade_in_value_cents',
  'trade_in_payoff_cents',
  'money_factor',
  'residual_percent',
  // Legacy keys from process-dealer-decision
  'apr',
  'down_payment',
  'monthly_payment',
  'miles_per_year',
  // Metadata (allowed but not "structured terms")
  'message',
  'expires_at',
] as const;

export const ALLOWED_COUNTER_OFFER_KEY_SET = new Set<string>(ALLOWED_COUNTER_OFFER_KEYS);

/**
 * Keys that are metadata, not structured financial terms.
 * Used to distinguish "has at least one real term" from "message-only".
 */
export const COUNTER_OFFER_METADATA_KEYS = new Set(['message', 'expires_at']);
